module.exports = __webpack_public_path__ + "static/img/logo.907564a6.png";